import { LISTS_DOC, PERSONAL_LISTS_DOC_PREFIX } from '@awwyeah/shared';
import type { WebModule } from '../registry';
import { ListDetailPage } from './ListDetailPage';
import { ListsIndexPage } from './ListsIndexPage';
import { ShoppingModePage } from './ShoppingModePage';
import { TemplatesPage } from './TemplatesPage';

/**
 * Lists module (client side, WS-5). Index + templates before `:listId` so the literal
 * `/lists/templates` route matches ahead of the param route.
 */
export const listsWebModule: WebModule = {
  id: 'lists',
  nav: { label: 'Lists', path: '/lists', icon: '📝', order: 20 },
  routes: [
    { path: '/lists', component: ListsIndexPage },
    { path: '/lists/templates', component: TemplatesPage },
    { path: '/lists/:listId/shop', component: ShoppingModePage },
    { path: '/lists/:listId', component: ListDetailPage },
  ],
  docs: [LISTS_DOC, PERSONAL_LISTS_DOC_PREFIX, 'list:'],
};

/**
 * The lists module's one published hook (WS-15). Any screen that needs "which lists can I
 * see" must go through this, because since WS-15 the answer is the merge of the shared
 * `lists` registry and my own `lists:user:<id>` one — reading `lists` directly is now a
 * bug that silently hides every private list. Recipes' "add ingredients to a list" picker
 * is the current caller.
 */
export { useVisibleLists } from './useListRegistries';
